import {useTranslation} from 'react-i18next';

export default function Image(props) {
    const {t} = useTranslation();

    return (
        <img className={props.image.className} src={props.image.src} alt={t(props.image.alt)}/>
    )
}